import React from 'react';
import './Navbar.css';
import "./style/logosli.css";
import "./style/slideNew.css";
import './Homes.css';
import styled from "styled-components";
import Footer from '../store/Components/Footer';
import SliderNew from './slideNew';
import LatestProd from '../store/Components/LatestProd';
import { NavLink } from "react-router-dom";
import { useState } from 'react';
import { publicRequest } from '../store/requestMethods';
const Center = styled.div`
  flex: 1;
  text-align: center;
`;

function Homes() {
  const [inputs, setInputs] = useState({ email: "" });
  const handleChange = (e) => {
    setInputs(prev => {
      return { ...prev, [e.target.name]: e.target.value };
    });
    console.log(inputs);
  };
  const handleClick = async (e) => {
    e.preventDefault();
    await publicRequest.post("/suggestion", inputs);
    setInputs({ name: "" });
  }
  return (
    <div>
      <div>
        <SliderNew />
      </div>

      <div className='infosection container'>
        <div className='infosectionIn'>
          <div className='infosectionInImage'>
            <img src="./images/slide31.jpg" alt="info" />
          </div>
          <div className='infosectionInCon'>
            <h3>WE ARE ALWAYS HERE FOR YOU..</h3>
            <p>We're your one-stop solution for all automobile brands, offering attractive prices, top-notch service, fast and easy repairs, and a customer-friendly approach, encompassing regular maintenance, taxi/rental, and accident services</p>
            <NavLink exact to="/contact">Contact Us</NavLink>
          </div>
        </div>
      </div>

      <div className="Services container">
        <h3 className='mb-12 text-3xl font-bold lg:text-5xl'>SERVICES</h3>
        <Center>
          <div className="">
            <section className="customer-logos">
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/services.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3 className="threeD">EService</h3>
                  <p>Your comprehensive vehicle solution</p>
                </div>
              </div>
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/fastag.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3>Fastag</h3>
                  <p>Smooth and hassle-free toll payments</p>
                </div>
              </div>
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/sparewheels.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3>Sparewheels</h3>
                  <p>Reliable spare parts when you need them.</p>
                </div>
              </div>
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/carwash.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3>Carwash</h3>
                  <p>Revitalize your vehicle's shine.</p>
                </div>
              </div>
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/schedule.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3>Schedule</h3>
                  <p>Stay on track with routine maintenance.</p>
                </div>
              </div>
              <div className="slide">
                <div className='logosimage'>
                  <img src="./images/services/battery.png" alt="services" />
                </div>
                <div className='logoscon'>
                  <h3>Battery</h3>
                  <p>Powering your journey with quality batteries.</p>
                </div>
              </div>
            </section>
          </div>
        </Center>
      </div>

      <div className='aboutsection py-5 container'>
        <div className='grid items-center md:grid-cols-2'>
          <div>
            <NavLink to="/about">
              <img src='https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt=''></img>
            </NavLink>
          </div>
          <div className='my-4 px-8 py-4 bg-[#ecc158]'>
            <h3 className='mb-5 text-2xl font-bold'>About Us</h3>
            <p className='text-[#fff] tracking-wider mb-4'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            <p className='text-[#fff] tracking-wider'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
            <h4 className='mt-5 italic font-thin tracking-widest text-2xl'>Lorem</h4>
          </div>
        </div>
      </div>

      <div className='ourProcessHome container'>
        <h3 className='mb-4 text-3xl font-bold lg:text-5xl'><span className="text-[#ecc158]">Our </span>Process</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        <div className='ourProcessHomeUp'>
          <div className='ourProcessHomeIn'>
            <div className='ourProcessHomeInShape'>
              <img src='./images/ico/touchIco.png' alt=''></img>
            </div>
            <h4>Pick A Plan</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
          <div className='ourProcessHomeIn'>
            <div className='ourProcessHomeInShape'>
              <img src='./images/ico/paymentIco.png' alt=''></img>
            </div>
            <h4>Make A Payment</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
          <div className='ourProcessHomeIn'>
            <div className='ourProcessHomeInShape'>
              <img src='./images/ico/carIco.png' alt=''></img>
            </div>
            <h4>Enjoy Our Products</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
        </div>
      </div>

      <div className='blogs py-10'>
        <h3 className='mb-12 text-3xl text-center font-bold lg:text-5xl'><span className="text-[#ecc158]">See Our Recent</span> Blogs</h3>
        <div className='container grid gap-10 mt-10 mb-20 lg:gap-10 md:grid-cols-3 lg:grid-cols-4 '>
          <div className=''>
            <div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/"><img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' /></NavLink></div>

            <NavLink to="/"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Lorem Ipsum</span></NavLink>

            <h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span></NavLink></h2>
          </div>
          <div className=''>
            <div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/"><img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' /></NavLink></div>

            <NavLink to="/"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Lorem Ipsum</span></NavLink>

            <h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span></NavLink></h2>
          </div>
          <div className=''>
            <div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/"><img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' /></NavLink></div>

            <NavLink to="/"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Lorem Ipsum</span></NavLink>

            <h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span></NavLink></h2>
          </div>
          <div className=''>
            <div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/"><img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' /></NavLink></div>

            <NavLink to="/"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Lorem Ipsum</span></NavLink>

            <h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span></NavLink></h2>
          </div>
        </div>
        <div className="mt-10 flex justify-center"><NavLink className="relative inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-2 pl-4 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:pointer-events-none disabled:opacity-40 dark:border-gray-500 dark:bg-gray-800 dark:text-gray-300" to="/"><span>View all Posts</span></NavLink></div>
      </div>

      <div className="container Store">
        <h2 className='mb-12 text-3xl font-bold lg:text-5xl border-b-4 py-2 border-solid	 border-[#ecc158]'><span className="text-[#ecc158]">Shop By</span> Category</h2>
        <div className="provide">
          <div className='storecat'>
            <div className='storecatImg'>
              <img src="./images/cat/accesorie.png" alt="serivices" />
            </div>
            <div className='storecattitle'>
              <h3>ACCESSORIES</h3>
            </div>
          </div>
          <div className='storecat'>
            <div className='storecatImg'>

              <img src="./images/cat/ridinggear.png" alt="serivices" />
            </div>
            <div className='storecattitle'>
              <h3>RIDING GEAR</h3>
            </div>
          </div>
          <div className='storecat'>
            <div className='storecatImg'>
              <img src="./images/cat/spareparts.png" alt="serivices" />
            </div>
            <div className='storecattitle'>
              <h3>SPARE PARTS</h3>
            </div>
          </div>
        </div>
      </div>
      <div className='container'>
        <main className="max-w-6xl mx-auto pt-10 pb-16 px-8">

          <div className="max-w-md mx-auto mb-14 text-center">
            <h3 className="mb-12 text-3xl font-bold mb-6 lg:text-5xl"><span className="text-[#ecc158]">Flexible</span> Plans</h3>
            <p className="text-xl text-gray-500 font-medium">Choose a plan that works best for you and your team.</p>
          </div>

          <div className="flex flex-col justify-between items-center lg:flex-row lg:items-start">

            <div className="w-full flex-1 mt-8 p-8 order-2 bg-white shadow-xl rounded-3xl sm:w-96 lg:w-full lg:order-1 lg:rounded-r-none">
              <div className="mb-7 pb-7 flex items-center border-b border-gray-300">
                <div className="ml-5">
                  <span className="block text-2xl font-semibold">Basic</span>
                  <span><span className="font-medium text-gray-500 text-xl align-top">₹</span><span className="text-3xl font-bold">1000 </span></span><span className="text-gray-500 font-medium">/ user</span>
                </div>
              </div>
              <ul className="mb-7 font-medium text-gray-500">
                <li className="flex text-lg mb-2">
                  <span className="ml-3">Lorem ipsum <span className="text-black">Lorem</span></span>
                </li>
                <li className="flex text-lg mb-2">
                  <span className="ml-3">Lorem <span className="text-black">Lorem ipsum</span></span>
                </li>
                <li className="flex text-lg">
                  <span className="ml-3"><span className="text-black">Lorem</span> Lorem ipsum</span>
                </li>
              </ul>
              <a href="#/" className="flex justify-center items-center bg-indigo-600 rounded-xl py-5 px-4 text-center text-white text-xl">
                Select_Lorem
              </a>
            </div>

            <div className="w-full flex-1 p-8 order-1 shadow-xl rounded-3xl bg-gray-900 text-gray-400 sm:w-96 lg:w-full lg:order-2 lg:mt-0">
              <div className="mb-8 pb-8 flex items-center border-b border-gray-600">
                <div className="ml-5">
                  <span className="block text-3xl font-semibold text-white">Lorem</span>
                  <span><span className="font-medium text-xl align-top">₹</span><span className="text-3xl font-bold text-white">2400 </span></span><span className="font-medium">/ user</span>
                </div>
              </div>
              <ul className="mb-10 font-medium text-xl">
                <li className="flex mb-6">
                  <span className="ml-3">Lorem ipsum<span className="text-white">Lorem</span></span>
                </li>
                <li className="flex mb-6">
                  <span className="ml-3">Lorem <span className="text-white">call scheduling</span></span>
                </li>
                <li className="flex">
                  <span className="ml-3"><span className="text-white">Lorem</span> Lorem ipsum</span>
                </li>
              </ul>
              <a href="#/" className="flex justify-center items-center bg-indigo-600 rounded-xl py-6 px-4 text-center text-white text-2xl">
                Select_Lorem
              </a>
            </div>

            <div className="w-full flex-1 mt-8 p-8 order-3 bg-white shadow-xl rounded-3xl sm:w-96 lg:w-full lg:order-3 lg:rounded-l-none">
              <div className="mb-7 pb-7 flex items-center border-b border-gray-300">
                <div className="ml-5">
                  <span className="block text-2xl font-semibold">Lorem</span>
                  <span><span className="font-medium text-gray-500 text-xl align-top">₹</span><span className="text-3xl font-bold">3005 </span></span><span className="text-gray-500 font-medium">/ user</span>
                </div>
              </div>
              <ul className="mb-7 font-medium text-gray-500">
                <li className="flex text-lg mb-2">
                  <span className="ml-3">Lorem ipsum <span className="text-black">Lorem</span></span>
                </li>
                <li className="flex text-lg mb-2">
                  <span className="ml-3">Lorem <span className="text-black">ipsum</span></span>
                </li>
                <li className="flex text-lg">
                  <span className="ml-3"><span className="text-black">Lorem</span> cloud ipsum</span>
                </li>
              </ul>
              <a href="#/" className="flex justify-center items-center bg-indigo-600 rounded-xl py-5 px-4 text-center text-white text-xl">
                Select_Lorem
              </a>
            </div>

          </div>

        </main>
      </div>

      <LatestProd></LatestProd>

      {/* Testimonials */}

      <div className="container my-16 mx-auto">
        <section className="mb-32 text-center">
          <h2 className="mb-12 text-3xl font-bold lg:text-5xl">Testimonials</h2>

          <div className="grid gap-x-6 md:grid-cols-3 xl:gap-x-12">
            <div className="mb-6 lg:mb-0">
              <div
                className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
                <div className="relative overflow-hidden bg-cover bg-no-repeat">
                  <img src="https://mdbcdn.b-cdn.net/img/new/avatars/6.jpg" className="w-full rounded-t-lg" alt='' />
                  <a href="#!">
                    <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
                  </a>
                  <svg className="absolute left-0 bottom-[-3px] text-white dark:text-neutral-700" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 320">
                    <path fill="currentColor"
                      d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                    </path>
                  </svg>
                </div>
                <div className="p-6">
                  <h5 className="mb-2 text-lg font-bold">Halley Frank</h5>
                  <h6 className="mb-4 font-medium text-primary dark:text-primary-400">
                    Marketing Specialist
                  </h6>
                  <ul className="mb-6 flex justify-center">
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m480 757 157 95-42-178 138-120-182-16-71-168v387ZM233 976l65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                  </ul>
                  <p>
                    At vero eos et accusamus et iusto odio dignissimos ducimus qui
                    blanditiis praesentium accusamus voluptatum deleniti atque
                    corrupti.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-6 lg:mb-0">
              <div
                className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
                <div className="relative overflow-hidden bg-cover bg-no-repeat">
                  <img src="https://mdbcdn.b-cdn.net/img/new/avatars/8.jpg" className="w-full rounded-t-lg" alt='' />
                  <a href="#!">
                    <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
                  </a>
                  <svg className="absolute left-0 bottom-[-3px] text-white dark:text-neutral-700" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 320">
                    <path fill="currentColor"
                      d="M0,96L48,128C96,160,192,224,288,240C384,256,480,224,576,213.3C672,203,768,213,864,202.7C960,192,1056,160,1152,128C1248,96,1344,64,1392,48L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                    </path>
                  </svg>
                </div>
                <div className="p-6">
                  <h5 className="mb-2 text-lg font-bold">John Doe</h5>
                  <h6 className="mb-4 font-medium text-primary dark:text-primary-400">
                    Web Developer
                  </h6>
                  <ul className="mb-6 flex justify-center">
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                  </ul>
                  <p>
                    Ut pretium ultricies dignissim. Sed sit amet mi eget urna
                    placerat vulputate. Ut vulputate est non quam dignissim
                    elementum.
                  </p>
                </div>
              </div>
            </div>

            <div className="">
              <div
                className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
                <div className="relative overflow-hidden bg-cover bg-no-repeat">
                  <img src="https://mdbcdn.b-cdn.net/img/new/avatars/15.jpg" className="w-full rounded-t-lg" alt='' />
                  <a href="#!">
                    <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
                  </a>
                  <svg className="absolute left-0 bottom-[-3px] text-white dark:text-neutral-700" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 320">
                    <path fill="currentColor"
                      d="M0,288L48,256C96,224,192,160,288,160C384,160,480,224,576,213.3C672,203,768,117,864,85.3C960,53,1056,75,1152,69.3C1248,64,1344,32,1392,16L1440,0L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                    </path>
                  </svg>
                </div>
                <div className="p-6">
                  <h5 className="mb-2 text-lg font-bold">Lisa Trey</h5>
                  <h6 className="mb-4 font-medium text-primary dark:text-primary-400">
                    Public Relations
                  </h6>
                  <ul className="mb-6 flex justify-center">
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                      </svg>
                    </li>
                    <li>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960" className="w-5 text-warning">
                        <path fill="currentColor"
                          d="m323 851 157-94 157 95-42-178 138-120-182-16-71-168-71 167-182 16 138 120-42 178Zm-90 125 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-355Z" />
                      </svg>
                    </li>
                  </ul>
                  <p>
                    Enim ad minima veniam, quis nostrum exercitationem ullam
                    corporis suscipit laboriosam, nisi ut aliquid.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


      <div className='contact_us home'>
        <img src='./images/newsl.jpg' alt=''></img>
        <div><h2 className="love">GET LATEST UPDATES</h2></div>
        <div className='container'>
          <div className='contactForm'>
            <form>
              <input type='text' placeholder="Enter Your Email" name='email' value={inputs.email} onChange={handleChange} />
              {/* <input type='text' placeholder="" className="message" name="suggestion" value={inputs.suggestion} onChange={handleChange} /> */}
              {/* <textarea name="suggestion" placeholder="Enter Your Message" value={inputs.suggestion} onChange={handleChange} className="message">
							</textarea> */}
              <button onClick={handleClick}>SUBSCRIBE</button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Homes;
